import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import SillCalculator from "@/pages/SillCalculator";
import ShelvingCalculator from "@/pages/ShelvingCalculator";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import RecentOrders from "@/pages/RecentOrders";
import InstallationGuide from "@/pages/InstallationGuide";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Visualiser from "@/pages/Visualiser";

function App() {
  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/calculator" element={<Navigate to="/calculator/sills" replace />} />
          <Route path="/calculator/sills" element={<SillCalculator />} />
          <Route path="/calculator/shelving" element={<ShelvingCalculator />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:productId" element={<ProductDetail />} />
          <Route path="/visualiser" element={<Visualiser />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/orders" element={<RecentOrders />} />
          <Route path="/installation" element={<InstallationGuide />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
